/* eslint-disable */
export interface BlockquoteData {
  /** Indentation level from 1-4. */
  indentation: number;
}

const baseBlockquoteData: object = { indentation: 0 };

export const BlockquoteData = {
  fromJSON(object: any): BlockquoteData {
    const message = { ...baseBlockquoteData } as BlockquoteData;
    message.indentation =
      object.indentation !== undefined && object.indentation !== null
        ? Number(object.indentation)
        : 0;
    return message;
  },

  toJSON(message: BlockquoteData): unknown {
    const obj: any = {};
    message.indentation !== undefined &&
      (obj.indentation = Math.round(message.indentation));
    return obj;
  },
};
